export const estudianteTypes = {
    ESTUDIANTE_SAVE_START: '[Estudiante] SAVE_START',
    ESTUDIANTE_SAVE_COMPLETE: '[Estudiante] SAVE_COMPLETE',
    ESTUDIANTE_SAVE_ERROR: '[Estudiante] SAVE_ERROR',
    ESTUDIANTE_VALIDATED: '[Estudiante] VALIDATED',
    ESTUDIANTE_SET_OBSERVACION: '[Estudiante] SET_OBSERVACION',
    ESTUDIANTE_GET_FORMATOS: '[Estudiante] GET_FORMATOS',
    ESTUDIANTE_UPDATED: '[Estudiante] UPDATE'  
}